import { useState } from "react";
import { TOPIC_LIST } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

export default function Topics() {
  const [followed, setFollowed] = useState<number[]>([]);
  const toggle = (id: number) =>
    setFollowed((cur) => (cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id]));

  return (
    <section id="topics" className="bg-background-100 py-14 md:py-20">
      <SectionHeader
        eyebrow="话题追踪 / FOLLOW"
        title="本月大瓜猛料进度，一键持续跟进"
        desc="为正在发酵的本月大瓜话题建立追踪面板，进度条反映事件所处的发酵阶段，点击关注即可把话题加入你的吃瓜清单。"
        accent
      />

      <div className="mx-auto mt-8 grid w-full max-w-7xl grid-cols-1 gap-5 px-4 md:px-6 sm:grid-cols-2 lg:grid-cols-3">
        {TOPIC_LIST.map((t) => {
          const isFollow = followed.includes(t.id);
          return (
            <article
              key={t.id}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition hover:border-accent-300"
            >
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{t.name}</h3>
                <button
                  type="button"
                  onClick={() => toggle(t.id)}
                  className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition ${
                    isFollow
                      ? "bg-primary-500 text-background-50"
                      : "border border-background-300 bg-background-100 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
                  }`}
                >
                  <i className={isFollow ? "ri-check-line" : "ri-add-line"} />
                  {isFollow ? "已关注" : "关注"}
                </button>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{t.desc}</p>

              <div className="mt-5">
                <div className="flex items-center justify-between text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-group-line text-secondary-700" /> {t.members} 人跟进
                  </span>
                  <span className="inline-flex items-center gap-1 font-semibold text-accent-700">
                    <i className="ri-time-line" /> {t.status}
                  </span>
                </div>
                <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-secondary-100">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                    style={{ width: `${t.progress}%` }}
                  />
                </div>
                <div className="mt-2 text-right text-[11px] font-medium text-secondary-700">
                  发酵进度 {t.progress}%
                </div>
              </div>

              <span className="mt-4 inline-flex w-fit items-center gap-1 rounded-md bg-secondary-100 px-2 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-price-tag-3-line" /> {t.tag}
              </span>
            </article>
          );
        })}
      </div>
    </section>
  );
}